import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Wrapper } from '../css_global/utils.css';
import Country from '../../common/models/Country';
import {
  ReviewsCreditCards,
  ReviewsExample,
  ReviewsInvitation,
  ReviewsList,
  ReviewsOrderProcessing,
} from '../../components_common/Reviews';
import VerticalSpacer from '../../components_common/VerticalSpacer';
import PageHeading from '../components/PageHeading';

const mapStateToProps = ({ api: { countryId } }) => ({
  isUsdOrder: countryId === Country.unitedStates(),
});

const Reviews = ({ isUsdOrder }) => (
  <div>
    <VerticalSpacer height="62px" />

    <PageHeading text="ITALIST REVIEWS" />
    <VerticalSpacer height="22px" />

    <Wrapper padding="0 180px">
      <ReviewsExample />
    </Wrapper>
    <VerticalSpacer height="20px" />

    <Wrapper padding="0 90px" textAlign="center">
      <ReviewsInvitation />
    </Wrapper>
    <VerticalSpacer height="34px" />

    <Wrapper style={{ display: 'flex' }}>
      <Wrapper width="60%">
        <ReviewsList />
      </Wrapper>
      <Wrapper width="40%" margin="0 0 10px" padding="0 120px 0 40px" textAlign="justify">
        <ReviewsCreditCards isDesktop isUsdOrder={isUsdOrder} />
        <ReviewsOrderProcessing />
      </Wrapper>
    </Wrapper>
  </div>
);

Reviews.propTypes = {
  isUsdOrder: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(Reviews);
